export default "__VITE_ASSET__7f0c6074__"